import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js'
import { Fancybox } from "@fancyapps/ui";

export default class extends Controller {
  static targets = ["codeInput", 'invalidCode', 'mailSent', 'resend']
  static classes = ['hidden', 'visible']
  static values = {
    url: String,
    resendUrl: String
  }

  connect () {
    const otpContainer = this.element.querySelector('#otp-input')
    const hiddenInput = this.codeInputTarget

    this.otpInput = new VanillaOTP(otpContainer, hiddenInput)
  }

  async createVerificationCode (email) {
    const request = new FetchRequest('post', this.resendUrlValue, {
      body: { subject: email }
    })

    await request.perform()
  }

  showInvalidCode () {
    this.invalidCodeTarget.classList.remove(this.hiddenClass)
  }

  hideInvalidCode () {
    this.invalidCodeTarget.classList.add(this.hiddenClass)
  }

  hideMailSentMessage () {
    this.mailSentTarget.classList.remove(this.visibleClass)
    this.mailSentTarget.classList.add(this.hiddenClass)
  }

  resend (event) {
    event.preventDefault()

    this.createVerificationCode(this.element.dataset.unverifiedEmail)

    this.mailSentTarget.classList.add(this.visibleClass)
    this.mailSentTarget.classList.remove(this.hiddenClass)

    this.resendTarget.classList.remove(this.visibleClass)
    this.resendTarget.classList.add(this.hiddenClass)
  }

  showResendEmail () {
    this.resendTarget.classList.remove(this.hiddenClass)
    this.resendTarget.classList.add(this.visibleClass)
  }

  verifyVerificationCode (event) {
    event.preventDefault()

    const verificationCode = this.codeInputTarget.value

    if (verificationCode) {
      const request = new FetchRequest('post', this.urlValue, {
        body: {
          code: verificationCode,
          subject: this.element.dataset.unverifiedEmail
        }
      })

      request.perform().then((response) => {
        if (response.ok) {
          // We manually dispatch a custom 'verified' event when the verification request succeeds.
          // This allows other Stimulus controllers to react to the successful verification,
          // in this case email_verifcation_controller.js to call its verificationCodeVerified() method,
          // which closes the fancybox and updates the UI accordingly.
          this.dispatch('verified')

          // Reset messages so that user can ask for resending email again
          this.hideMailSentMessage()
          this.showResendEmail()

          // Clear input field
          if (this.otpInput.inputs && this.otpInput.inputs.length > 0) {
            this.otpInput.inputs.forEach(input => input.value = '')
          }
        } else {
          this.showInvalidCode()
        }
      })
    }
  }
}
